import Avatar from "../assets/svg/header/avatar.svg";
export const headerData = {
	name: "Lalit Rajput",
	title: "Hello! I am",
	desciption:
		"Hello! I am Lalit Rajput, a professional and passionate programmer in my daily life. A quick learner with a self-learning attitude. I love to learn and explore new technologies and am Passionate about Problem Solving. ",
	image: Avatar,
	imagebw: "https://i.ibb.co/Cw2Xp90/abu-said-bw.jpg",
	resumePdf:
		"https://drive.google.com/file/d/1ih9BcFrNfW9UHOaRxcr1t2HsEM8BoPcS/view?usp=sharing",
};
